import api from "../helpers/axios";

class FileRelationService {
  /**
   * Get file relations by collection ID
   * @param {string} collectionId - Collection UUID
   * @param {boolean} bustCache - Whether to add cache-busting parameter
   * @returns {Promise<Array>} Array of file relation objects
   */
  async getFileRelations(collectionId, bustCache = false) {
    try {
      const url = `/file-relations/?collection_id=${collectionId}`;
      const finalUrl = bustCache ? `${url}&t=${Date.now()}` : url;

      const response = await api.get(finalUrl);
      return response.data;
    } catch (error) {
      console.error("Error fetching file relations:", error);
      throw error;
    }
  }

  /**
   * Create file relations for uploaded files
   * @param {Array} relations - Array of file relation objects
   * @returns {Promise<Array>} Created file relation data
   */
  async createFileRelations(relations) {
    try {
      const payload = {
        relations: relations,
      };

      const response = await api.post("/file-relations/", payload);
      return response.data;
    } catch (error) {
      console.error("Error creating file relations:", error);
      throw error;
    }
  }

  /**
   * Delete a file relation
   * @param {string} relationId - File relation ID
   * @returns {Promise<void>}
   */
  async deleteFileRelation(relationId) {
    try {
      await api.delete(`/file-relations/${relationId}`);
    } catch (error) {
      console.error("Error deleting file relation:", error);
      throw error;
    }
  }

  /**
   * Delete file relation by file ID and collection ID
   * @param {string} fileId - File ID
   * @param {string} collectionId - Collection ID
   * @returns {Promise<Object>} Delete response
   */
  async deleteFileRelationByIds(fileId, collectionId) {
    try {
      const response = await api.delete(
        `/file-relations/delete?file_id=${fileId}&collection_id=${collectionId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting file relation by IDs:", error);
      throw error;
    }
  }

  /**
   * Get file relations by facility ID
   * @param {string} facilityId - Facility UUID
   * @param {boolean} bustCache - Whether to add cache-busting parameter
   * @returns {Promise<Array>} Array of file relation objects
   */
  async getFileRelationsByFacility(facilityNumber, bustCache = false) {
    try {
      const params = new URLSearchParams({
        relation_type: "facility_context",
        facility_id: facilityNumber,
    });
      const url = `/file-relations/?${params}`;
      const finalUrl = bustCache ? `${url}&t=${Date.now()}` : url;
      const response = await api.get(finalUrl);
      return response.data;
    } catch (error) {
      console.error("Error fetching facility file relations:", error);
      throw error;
    }
  }
}

export default new FileRelationService();
